export default "__VITE_ASSET__BI3Br4gg__"